import { render } from "./SupportSection.vue?vue&type=template&id=4426c9a3&scoped=true"
import script from "./SupportSection.vue?vue&type=script&lang=js"
export * from "./SupportSection.vue?vue&type=script&lang=js"

import "./SupportSection.vue?vue&type=style&index=0&id=4426c9a3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4426c9a3"]])

export default __exports__